import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { DTOException } from '../../../../../@core/models/DTOException';
import { DTOSubException } from '../../../../../@core/models/DTOSubException';
import { Stop } from '../../../../../@core/models/live-route';
import { LiveRouteStatus } from '../../../../../@core/models/live-route-status';
import { ParcelHistories } from '../../../../../@core/models/parcel-histories';
import { ApiProvider } from '../../../../../@core/providers/api.provider';
import { AuthenticationService } from '../../../../../@core/services/authentication.service';
import { StopService } from '../../../../../@core/services/stop.service';
import { AddExceptionDialogComponent } from '../../../../../@theme/components';
import { DTOParcelHistories } from '../../../../../@core/models/DTOParcelHistories';
import { DTOShipment } from '../../../../../@core/models/DTOShipment';
import { DTOStop } from '../../../../../@core/models/DTOStop';
import { DTOParcelInfo } from '../../../../../@core/models/DTOParcelInfo';
import { DTOParcelHistory } from '../../../../../@core/models/DTOParcelHistory';
import { exceptionsData } from '../../exceptions.data';
import {
  ConfirmDialogComponent,
  ConfirmDialogModel
} from '../../../../../@theme/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'crm-add-exception-dialog',
  templateUrl: './crm-add-exception-dialog.component.html',
  styleUrls: ['./crm-add-exception-dialog.component.scss']
})
export class CrmAddExceptionDialogComponent implements OnInit {
  public selectedExceptionId: number = 0;
  public selectedSubExceptionId5: number = 0;
  public selectedSubExceptionId40: number = 0;
  public reason: string = '';
  public visitCode: string = '';
  public contact: string = '';
  public displaySendBtn: boolean = false;
  public selectedParcels: DTOParcelInfo[];
  public submitted: boolean = false;
  public shipment: DTOShipment;
  public key: string;

  public ionDateString: string;
  public ionExceptionDateString: string;
  public ionDatelivString: string;
  public maxDateTimeString: string;
  public todayString: string;
  public nextBusinessDay: Date;
  public minDate: Date = new Date();
  public maxDate: Date = new Date();

  public allowedExceptions: DTOException[];
  public selectedException: DTOException;
  public selectedSubException: DTOSubException;
  userId: string;
  lang: string;

  isLoading: boolean = false;

  constructor(
    public apiProvider: ApiProvider,
    public _stopService: StopService,
    private datePipe: DatePipe,
    public _translateService: TranslateService,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public dialogRef: MatDialogRef<AddExceptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.maxDateTimeString = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddThh:mm'
    );
    const moment = require('moment-business-days');
    this.nextBusinessDay = moment().nextBusinessDay().startOf('day').toDate();
    this.todayString = this.nextBusinessDay.toISOString();
    this.ionExceptionDateString = this.datePipe.transform(
      new Date(),
      'yyyy-MM-dd'
    );
    this.ionDatelivString = this.datePipe.transform(
      new Date(),
      'yyyy-MM-ddTHH:mm'
    );
    /*if (this.nextBusinessDay.getDay() == 5) {
      this.nextBusinessDay.setDate(this.nextBusinessDay.getDate() + 3);
      this.ionDateString = this.nextBusinessDay.toISOString();
    } else {
      this.nextBusinessDay.setDate(this.nextBusinessDay.getDate() + 1);
      this.ionDateString = this.nextBusinessDay.toISOString();
    }*/
    this.ionDateString = this.nextBusinessDay.toISOString();
    /*if (
      this.data &&
      this.data.nonCompletedStops &&
      this.data.nonCompletedStops.length > 0
    ) {
      this.selectedStops = this.data.nonCompletedStops;
    } else {
      this.selectedStops = this._stopService.selectedStops;
    }*/

    let isAdminTPSLRoute = false;

    let user : any = JSON.parse(localStorage.getItem('currentUser'));
  // Check if user have right to see AdminTPSLRoute exceptions
    if(user && user.UserName){
      if(user.UserName.GroupRights_Natpro && user.UserName.GroupRights_Natpro.length > 0){
        for(let right of user.UserName.GroupRights_Natpro){
          if(right.module_natpro_ID === 38 && right.write_access){
            isAdminTPSLRoute = true;
            break;
          }
        }
      }
    }

    if(!isAdminTPSLRoute){
      this.allowedExceptions = exceptionsData.filter((ex => !ex.AdminTPSLRoute));
    } else {
      this.allowedExceptions = exceptionsData;
    }

    this.selectedParcels = this.data.parcels;
    this.shipment = this.data.shipment;
    this.userId = this.data.userId;
    this.key = this.data.key;
    this.lang = this.data.lang;
    this._translateService.use(this.lang);
  }

  public goBack(): void {
    this.dialogRef.close(false);
  }

  public getDisplayReasonClass(): string {
    if (this.canDisplayReason()) {
      return '';
    } else {
      this.reason = '';
      return 'invisible';
    }
  }

  public canDisplayReason() {
    return (
      this.selectedException.ExceptionId == 3 ||
      this.selectedSubExceptionId40 == 400 ||
      this.selectedSubExceptionId5 == 302
    );
  }

  public getDisplayContactClass(): string {
    if (this.canDisplayContact()) {
      return '';
    } else {
      this.contact = '';
      return 'invisible';
    }
  }

  public canDisplayContact() {
    return (
      this.selectedException.ExceptionId == 4 ||
      this.selectedException.ExceptionId == 119
    );
  }

  public getDisplayDatelivDateClass() {
    if (this.canDisplayDatelivDate()) {
      return '';
    } else {
      return 'invisible';
    }
  }

  public getDisplayPostponedDateClass() {
    if (this.canDisplayPostponedDate()) {
      return '';
    } else {
      return 'invisible';
    }
  }

  public canDisplayPostponedDate() {
    return this.selectedSubExceptionId5 == 200 || this.selectedException == 9;
  }

  public deliveryNextBusinessDate(exceptionId: any) {
    return (
      exceptionId == 5 ||
      exceptionId == 14 ||
      exceptionId == 42 ||
      exceptionId == 43 ||
      exceptionId == 44 ||
      exceptionId == 68 ||
      exceptionId == 77
    );
  }

  public canDisplayDatelivDate() {
    return this.selectedExceptionId == 119 ||
      (this.authenticationService.currentUserValue &&
        this.authenticationService.currentUserValue.AdminTPSLRoute)
      ? this.authenticationService.currentUserValue.AdminTPSLRoute
      : false;
  }

  public anyFieldChange(): void {
    this.displayDoneButton();
  }

  public sendClick(): void {
    // this.functionModule.startWaiting();
    this.isLoading = true;
    this.submitted = true;
    const parcelHistories = this.getParcelHistories();
    const insertParcelHistories = this.apiProvider.InsertParcelHistories(
      parcelHistories,
      this.userId,
      this.key
    );
    let changeLiveRouteStatus = 3;
    if (this.selectedException == 119) {
      changeLiveRouteStatus = 4;
    }

    if (parcelHistories.ExceptionId == 68) {
      // this.functionModule.stopWaiting();
      insertParcelHistories.subscribe((results) => {
        if (this.data === null) {
          parcelHistories.ParcelIds.forEach((x) =>
            this._stopService.ChangeParcelStatus(x, changeLiveRouteStatus)
          );
        }

        let parcelHistory: DTOParcelHistory = {
          ProcessedDate: new Date(parcelHistories.ProcessedDate),
          ExceptionId: parcelHistories.ExceptionId,
          DescriptionFr: this.selectedException.TxtFrench,
          DescriptionEn: this.selectedException.TxtEnglish,
          UserName:
            this.authenticationService.currentUserValue.firstname +
            ' ' +
            this.authenticationService.currentUserValue.Name,
          Tpsl: 0
        };
      });
      this.confirmSave();
    } else {
      // this.functionModule.stopWaiting();
      insertParcelHistories.subscribe((results) => {
        if (this.data === null) {
          parcelHistories.ParcelIds.forEach((x) =>
            this._stopService.ChangeParcelStatus(x, changeLiveRouteStatus)
          );
        }

        let parcelHistory: DTOParcelHistory = {
          ProcessedDate: new Date(parcelHistories.ProcessedDate),
          ExceptionId: parcelHistories.ExceptionId,
          DescriptionFr: this.selectedException.TxtFrench,
          DescriptionEn: this.selectedException.TxtEnglish,
          UserName:
            this.authenticationService.currentUserValue.firstname +
            ' ' +
            this.authenticationService.currentUserValue.Name,
          Tpsl: 0
        };
        this.dialogRef.close(parcelHistory);
      });
    }
  }

  private displayDoneButton(): void {
    if (this.selectedException == 0) {
      this.displaySendBtn = false;
    } else if (this.canDisplayContact() && this.contact.length < 2) {
      this.displaySendBtn = false;
    } else if (this.canDisplayReason() && this.reason.length < 2) {
      this.displaySendBtn = false;
    } else {
      this.displaySendBtn = true;
    }
  }

  public confirmSave(): void {
    /*if (
      this.shipmentStatus === 'Cancelled' ||
      this.shipmentStatus === 'OnHold'
    ) {*/
    const message = this._translateService.instant(
      'crm.confirm-reactivate-shipment'
    );

    const dialogData = new ConfirmDialogModel('Confirm Action', message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: `400px`,
      data: dialogData
    });

    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
        const parcelIds: number[] = [];
        this.selectedParcels.filter((x) => parcelIds.push(x.ParcelId));
        const parcelHistories: DTOParcelHistories = {
          ParcelIds: parcelIds,
          ExceptionId: 42,
          PostponedDate: '',
          ProcessedDate: new Date().toISOString(),
          SubExceptionId: 0,
          Contact: this.contact,
          UserId: this.authenticationService.currentUserValue.UserID,
          SourceType: 401
        };
        const insertParcelHistories = this.apiProvider.InsertParcelHistories(
          parcelHistories,
          this.userId,
          this.key
        );
        let changeLiveRouteStatus = 3;
        if (this.selectedException == 119) {
          changeLiveRouteStatus = 4;
        }
        insertParcelHistories.subscribe((results) => {
          if (this.data === null) {
            parcelHistories.ParcelIds.forEach((x) =>
              this._stopService.ChangeParcelStatus(x, changeLiveRouteStatus)
            );
          }
          let parcelHistory: DTOParcelHistory = {
            ProcessedDate: new Date(parcelHistories.ProcessedDate),
            ExceptionId: parcelHistories.ExceptionId,
            DescriptionFr: this.selectedException.TxtFrench,
            DescriptionEn: this.selectedException.TxtEnglish,
            UserName:
              this.authenticationService.currentUserValue.firstname +
              ' ' +
              this.authenticationService.currentUserValue.Name,
            Tpsl: 0
          };
          // this.functionModule.stopWaiting();
          this.dialogRef.close(parcelHistory);
        });
      } else {
        this.dialogRef.close(null);
      }
    });
    /* } else {
      this.save(false);
    }*/
  }

  public getParcelHistories(): DTOParcelHistories {
    const parcelIds: number[] = [];
    this.selectedParcels.filter((x) => parcelIds.push(x.ParcelId));
    const parcelHistories: DTOParcelHistories = {
      ParcelIds: parcelIds,
      ExceptionId: Number(this.selectedException.ExceptionId),
      PostponedDate: '',
      ProcessedDate: new Date().toISOString(),
      SubExceptionId: 0,
      Contact: this.contact,
      UserId: this.authenticationService.currentUserValue.UserID,
      SourceType: 401
    };

    if (
      this.selectedException.PostponedDateAllowed ||
      this.deliveryNextBusinessDate(this.selectedException.ExceptionId)
    ) {
      parcelHistories.PostponedDate = new Date(
        this.ionDateString
      ).toISOString();
    }
    if (Number(this.selectedSubExceptionId5) > 0) {
      parcelHistories.SubExceptionId = Number(this.selectedSubExceptionId5);
    }
    if (Number(this.selectedSubExceptionId40) > 0) {
      parcelHistories.SubExceptionId = Number(this.selectedSubExceptionId40);
    }
    parcelHistories.Reason = this.reason;
    if (this.visitCode.length > 0) {
      parcelHistories.VisitCode = Number(this.visitCode);
    }
    return parcelHistories;
  }
}
